import { BarChart3, Briefcase, Building2, CreditCard, FileText, History, Home, TriangleAlert, UserCog, Users } from "lucide-react";
import { Menu } from "@/types/menu";

export const menus: Menu[] = [
    {
      title: 'Página inicial',
      icon: (className?: string) => <Home className={className} />,
      href: '/'
    },
    {
      title: 'Seguros',
      icon: (className?: string) => <FileText className={className} />,
      href: '/seguros',
      permissao: 'SEGURO_READ',
      secao: 'Carteira'
    },
    {
      title: 'Sinistros',
      icon: (className?: string) => <TriangleAlert className={className} />,
      href: '/sinistro',
      permissao: 'SEGURO_READ',
      secao: 'Carteira'
    },
    {
      title: 'Segurados',
      icon: (className?: string) => <Users className={className} />,
      href: '/segurado',
      permissao: 'SEGURADO_READ',
      secao: 'Carteira'
    },
    {
      title: 'Seguradoras',
      icon: (className?: string) => <Building2 className={className} />,
      href: '/seguradora',
      permissao: 'SEGURADORA_READ',
      secao: 'Carteira'
    },
    {
      title: 'Relatórios',
      icon: (className?: string) => <BarChart3 className={className} />,
      href: '/relatorios',
      permissao: 'SEGURO_READ',
      secao: 'Gestão'
    },
    {
      title: 'Usuários',
      icon: (className?: string) => <UserCog className={className} />,
      href: '/usuario',
      permissao: 'USUARIO_READ',
      secao: 'Gestão'
    },
    {
      title: 'Auditoria',
      icon: (className?: string) => <History className={className} />,
      href: '/auditoria',
      permissao: 'AUDITORIA_READ',
      secao: 'Gestão'
    },
    {
      title: 'Corretora',
      icon: (className?: string) => <Briefcase className={className} />,
      href: '/empresa',
      permissao: 'EMPRESA_READ',
      secao: 'Gestão'
    },
    {
      title: 'Assinatura',
      icon: (className?: string) => <CreditCard className={className} />,
      href: '/assinatura',
      permissao: 'ADMIN',
      secao: 'Gestão'
    }
  ];
